import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SkillsReorderDialogData {
  title: string;
  skills: SkillItem[];
}

export interface SkillItem {
  id: string;
  skill_id: string | null;
  skill_name: string | null;
  rating: number | null;
  order: number;
  is_native?: boolean | null;
}

@Component({
  selector: 'bwc-skills-reorder-dialog',
  templateUrl: './skills-reorder-dialog.component.html',
  styleUrls: ['./skills-reorder-dialog.component.scss'],
})
export class SkillsReorderDialogComponent {
  skills: SkillItem[];

  constructor(
    private dialogRef: MatDialogRef<SkillsReorderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SkillsReorderDialogData
  ) {
    this.skills = data.skills.map((s, i) => ({ ...s, order: i }));
  }

  drop(event: CdkDragDrop<SkillItem[]>): void {
    moveItemInArray(this.skills, event.previousIndex, event.currentIndex);
    this.skills.forEach((skill, i) => (skill.order = i));
  }

  save(): void {
    this.dialogRef.close(this.skills);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
